import {
    Action,
    handleActions,
} from 'redux-actions';
import decodeJwt from 'jwt-decode';
import {LoginPayload} from '../LoginTypes';
import {
    User,
    UserState,
} from '../../types';

import {
    LOG_IN,
    LOG_OUT,
} from './LoginActions';

export const envAuth = process.env.REACT_APP_NO_AUTH || false;

export const logIn = (state: UserState, {payload}: Action<LoginPayload>) => {
    const {
        jwt,
        roles,
        email,
        status,
        name,
    } = payload;
    
    if (!jwt)
        return state;
    
    const {user} = decodeJwt(jwt);
    
    return {
        ...user,
        isAuthenticated: true,
        name,
        roles,
        email,
        status,
    };
};

export const logOut = (): User => {
    return {
        isAuthenticated: false,
        roles: [],
    };
};

const DEFAULT_STATE = {
    isAuthenticated: envAuth || Boolean(localStorage.getItem('jwt')),
    roles: [],
};

const handlers = {
    [LOG_IN]: logIn,
    [LOG_OUT]: logOut,
};

export default handleActions(handlers, DEFAULT_STATE);
